// src/components/RiskPriorityTable.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './DirectoryTable.css'; // здесь лежат стили .custom-table, .hov, .date-col и т.д.
import API_BASE_URL from '../../config';

const RiskPriorityTable = () => {
  const [collectors, setCollectors] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/v1/risk/top?limit=10`)
      .then((response) => {
        setCollectors(response.data);
      })
      .catch((error) => {
        console.error('Не удалось загрузить топ-10 коллекторов по риску:', error);
      });
  }, []);


  // Возвращает текстовый лейбл для risk_score
  const getRiskLabel = (score) => {
    if (score >= 0.8) return 'высокий';
    if (score >= 0.6) return 'средне-высокий';
    if (score >= 0.4) return 'средний';
    if (score >= 0.2) return 'средне-низкий';
    return 'низкий';
  };

  // Возвращает цвет текста в зависимости от risk_score:
  // от красного (макс) к зелёному (мин) через оттенки жёлтого/оранжевого
  const getRiskColor = (score) => {
    if (score >= 0.8) {
      return '#FF4C4C';      // ярко-красный
    }
    if (score >= 0.6) {
      return '#FFB84C';      // оранжевый
    }
    if (score >= 0.4) {
      return '#FFD54C';      // жёлтый
    }
    if (score >= 0.2) {
      return '#B2FF4C';      // жёлто-зелёный
    }
    return '#4CFF4C';        // ярко-зелёный
  };

  // Обработчик клика по строке
const handleRowClick = (collector) => {
  // 1) Сохраняем id в localStorage, так же, как
  //    вы делаете это на странице карты
  localStorage.setItem('openedCollectorId', collector.id);

    navigate(
      `/collectors/${collector.id}`,
      {
        state: {
          collectorData: collector,
          source: 'summary', // явно указываем, что пришли из Сводного анализа
        },
      }
    );
};

  return (
    <div className="table-container">
      <div className="table-wrapper">
        {/* Добавлен класс "hov" для hover-состояния */}
        <table className="custom-table hov">
          <colgroup>
            <col style={{ width: '15%' }} />  {/* Приоритет */}
            <col style={{ width: '55%' }} />  {/* Название коллектора */}
            <col style={{ width: '30%' }} />  {/* Риск поломки */}
          </colgroup>
          <thead>
            <tr>
              <th className="date-col">Приоритет</th>
              <th>Название коллектора</th>
              <th className="date-col">Риск поломки</th>
            </tr>
          </thead>
          <tbody>
            {collectors.map((item) => {
              const label = getRiskLabel(item.risk_score);
              const textColor = getRiskColor(item.risk_score);

              return (
                <tr
                  key={item.id}
                  className="clickable-row"
                  onClick={() => handleRowClick(item)}
                  style={{ cursor: 'pointer' }}
                >
                  {/* Ячейка с приоритетом */}
                  <td className="date-col">{item.priority}</td>

                  {/* Название коллектора */}
                  <td>{item.name}</td>

                  {/* Ячейка с риском: цвет теперь на тексте */}
                  <td
                    className="date-col"
                    style={{
                      color: textColor,
                      fontWeight: 'bold'
                    }}
                  >
                    {label}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RiskPriorityTable;
